import axios from "axios";
import config from "../config";

// refresh skips the API's cached answer, e.g. after the user comes back from subscribing
export function getPrimumSubscription(refresh = false) {
  return axios.get(`${config.api_url}/primum/subscription`, {
    params: refresh ? { refresh: 1 } : {},
  });
}

export function createPrimumMeeting(meeting) {
  return axios.post(`${config.api_url}/primum/meetings`, meeting);
}
